import React from 'react';
import { Box, IconButton } from '@mui/material';
import NavigateBefore from '@mui/icons-material/NavigateBefore';
import NavigateNext from '@mui/icons-material/NavigateNext';
import makeStyles from '@mui/styles/makeStyles';
import { useMessage } from 'modules/intl';
import { useFeatureFlag } from 'modules/common/hooks';

const useStyles = makeStyles((theme) => ({
  root: {
    display: 'flex',
    maxWidth: '70%',
    marginTop: theme.spacing(0.25)
  },
  period: {
    fontSize: '1.05rem',
    fontWeight: theme.typography.fontWeightMedium,
    display: 'flex',
    alignItems: 'center'
  },
  icon: {
    color: theme.palette.text.primary
  }
}));
type InsightsDateRangeArrowsProps = {
  disableNext: boolean;
  disablePrevious: boolean;
  updateNext: () => void;
  updatePrevious: () => void;
};

export const InsightsDateRangeArrows: React.FC<InsightsDateRangeArrowsProps> = ({
  disableNext,
  disablePrevious,
  updateNext,
  updatePrevious
}: InsightsDateRangeArrowsProps) => {
  const classes = useStyles();

  const isTiwScreenReaderEnabled = useFeatureFlag('isTiwScreenReaderEnabled');

  const prev = useMessage('insights.prev');
  const next = useMessage('insights.next');

  return (
    <Box className={classes.root} data-testid="insight-period-arrow">
      <IconButton
        size="small"
        data-testid="insight-period-previous"
        disabled={disablePrevious}
        onClick={updatePrevious}
        className={classes.icon}
        aria-label={isTiwScreenReaderEnabled ? prev : undefined}
      >
        <NavigateBefore />
      </IconButton>
      <IconButton
        size="small"
        data-testid="insight-period-next"
        disabled={disableNext}
        onClick={updateNext}
        className={classes.icon}
        aria-label={isTiwScreenReaderEnabled ? next : undefined}
      >
        <NavigateNext />
      </IconButton>
    </Box>
  );
};
